import React from 'react'

import { HeaderNav } from '@application/Types/HeaderTypes'
import { HeaderThemeModeType, NavigationThemeType } from '@src/Application/Types/ComponentTypes'

import { Navbar } from './Nav.styled'
import { NavItemElement } from './NavItemElement'

type NavProp = {
    nodes: HeaderNav[]
    className?: string
    mode: HeaderThemeModeType
    type: NavigationThemeType
}

export const Nav = ({ nodes, className, mode, type }: NavProp): JSX.Element => {
    return (
        <Navbar className={className} $mode={mode} $type={type}>
            {nodes.map((node, index) => (
                <NavItemElement index={index} node={node} key={index} />
            ))}
        </Navbar>
    )
}
